import { createFileRoute } from '@tanstack/react-router';
import { GuestLinkPage } from '@/features/meetings/pages/guest-link-page';

/** Public: the link of a guest invitation. It only moves the token out of the address bar. */
export const Route = createFileRoute('/meetings/join/$token')({
  component: GuestLinkRoute,
});

function GuestLinkRoute() {
  const { token } = Route.useParams();
  return <GuestLinkPage token={token} />;
}
